import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  PriceDetailCardDiscount, PriceDetailCardPrice, PriceDetailCardSubtitle, PriceDetailCardType
} from '@design-system/components/organisms/price-detail-card/entities/price-detail-card.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonIconSize } from '@design-system/components/molecules/button-icon/entities/button-icon.types';
import { AlertSize } from '@design-system/components/molecules/alert/entities/alert.types';
import { TagMemberType } from '@design-system/components/molecules/tag-member/entities/tag-member.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';
import { TagMemberDsComponent } from '@design-system/components/molecules/tag-member/tag-member.component';
import { AlertDsComponent } from '@design-system/components/molecules/alert/alert.component';


@Component({
  selector: 'app-ds-price-detail-card',
  templateUrl: './price-detail-card.component.html',
  styleUrls: ['./price-detail-card.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    DividerDsComponent,
    ButtonIconDsComponent,
    TagMemberDsComponent,
    AlertDsComponent,
  ]
})
export class PriceDetailCardDsComponent {

  @Input() type = PriceDetailCardType.Embedded;
  @Input() title: string;
  @Input() subtitles: PriceDetailCardSubtitle[] = [];
  @Input() rows: PriceDetailCardPrice[][] = [];
  @Input() discount: PriceDetailCardDiscount;
  @Input() total: PriceDetailCardPrice;
  @Input() subtotal: PriceDetailCardPrice;

  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  public readonly closeIcon = Icon.Close;
  public readonly warningIcon = Icon.Warning;

  public readonly buttonIconSize = ButtonIconSize.LG;

  public readonly alerSize = AlertSize.RG;

  constructor() { }

  get isEmbedded(): boolean {
    return this.type === PriceDetailCardType.Embedded;
  }

  get discountAmountColor(): TypographyColor {
    if (this.discount?.UseTagStyle) {
      if (this.discount?.TagMemberType === TagMemberType.Pro) {
        return TypographyColor.PrimeBranding;
      } else if (this.discount?.TagMemberType === TagMemberType.Pay) {
        return TypographyColor.Pay;
      } else {
        return TypographyColor.Neon;
      }
    } else {
      return TypographyColor.Neon;
    }
  }

  get discountLabelColor(): TypographyColor {
    if (this.discount?.UseTagStyle) {
      if (this.discount?.TagMemberType === TagMemberType.Pro) {
        return TypographyColor.PrimeBranding;
      } else if (this.discount?.TagMemberType === TagMemberType.Pay) {
        return TypographyColor.Pay;
      } else {
        return TypographyColor.Neon;
      }
    } else {
      return TypographyColor.Primary;
    }
  }

  public trackById(index: number): number {
    return index;
  }

}
